class Version {
    getVersion() {
        return "3.6.9";
    }
}

export default new Version();